module.exports = __webpack_public_path__ + "img/active-27.7c3fb361.svg";